import { isTesting, macroCondition } from '@embroider/macros';

import V2Adapter from './v2';

export default class GroupInviteRegistrationAdapter extends V2Adapter {
  shouldBackgroundReloadRecord() {
    return false;
  }

  pathForType() {
    return 'guest-group-invite-links';
  }

  // Always POST to /api/v2/guest-group-invite-links/invite
  urlForCreateRecord(modelName, snapshot) {
    let url = super.urlForCreateRecord(modelName, snapshot);

    url = `${url}/invite`;
    if (macroCondition(isTesting())) {
      // Add the `include` to avoid errors in tests since we don't reload the page in test (but do for other modes)
      return `${url}?include=sign-in-fields`;
    }
    return url;
  }

  // Override handleResponse to attach meta information to errors
  handleResponse(status, headers, payload, requestData) {
    const response = super.handleResponse(status, headers, payload, requestData);

    // If it's an error response and has meta information, attach it to the error
    if (response instanceof Error && payload && typeof payload === 'object' && 'meta' in payload) {
      response.meta = payload.meta;
    }

    return response;
  }
}
